<script setup lang="ts">
import { NButton, NDropdown } from "naive-ui";
import Icon from "@/components/GIcon/index.vue";

import router from "@/router";
import { useAppStore } from "@/store/modules/app";
import { usePermissionStore } from "@/store/modules/permission";
import DefaultHeader from "@/assets/images/header_default.png";
const permissionStore = usePermissionStore();

const appStore = useAppStore();

const options = computed(() => [
  {
    label: "个人资料",
    key: "edit",
    size: "small",
    show: Boolean(
      permissionStore.userRole?.companyCode && permissionStore.userRole?.member,
    ),
    icon: () =>
      h("div", {
        class: "iconfont icon-user-copy text-#222222 text-16px",
      }),
  },
  {
    label: "退出登录",
    key: "logout",
    size: "small",
    icon: () =>
      h(Icon, {
        name: "logout",
        size: "16px",
        color: "#222222",
      }),
  },
]);

function handleSelect(value: string) {
  const map = {
    logout() {
      appStore.logout();
    },
    edit() {
      const routeData = router.resolve({
        path: "/info",
      });
      window.open(routeData.href, "_blank");
    },
  };
  map[value]?.();
}
function goHome() {
  router.push("/");
}
</script>

<template>
  <div
    class="header bg-primary fixed items-center justify-between top-0 h-header left-0 right-0 transition-all duration-300 flex justify-between shadow-sm px-16px bg-[url('@/assets/images/header/header_bg.png')] bg-cover bg-no-repeat"
    :class="[appStore.collapsed ? 'left-sidebar--collapsed' : 'left-0']"
  >
    <div class="h-full flex items-center">
      <img
        src="@/assets/images/header/logo.png"
        class="h-28px w-162px"
        @click="goHome"
      />
    </div>

    <NDropdown
      v-if="appStore.token"
      trigger="click"
      :menu-props="
        () => ({
          style: {
            padding: '8px 0 !important',
          },
        })
      "
      :options="options"
      @select="handleSelect"
    >
      <div class="flex items-center gap-8px">
        <img
          :src="appStore.userInfo?.headShotUrl || DefaultHeader"
          class="w-32px h-32px rounded-full border-1px border-white/50"
        />
        <div>
          <div class="flex items-center gap-2px">
            <NButton size="small" text text-color="#ffffff">
              <div
                class="overflow-hidden whitespace-nowrap text-ellipsis max-w-100px text-13px text-white"
              >
                {{ appStore.userInfo?.userName }}
              </div>
            </NButton>
            <div
              v-if="permissionStore.userDetail?.postName"
              class="text-10px w-[fit-content] line-clamp-1 max-w-52px overflow-hidden whitespace-nowrap text-ellipsis text-white bg-[rgba(255,255,255,0.2)] px-4px rounded-2px box-content leading-14px"
            >
              {{ permissionStore.userDetail?.postName }}
            </div>
          </div>
          <div
            class="text-#ffffff/80 text-10px max-w-160px overflow-hidden whitespace-nowrap text-ellipsis"
          >
            {{ permissionStore.userDetail?.companyName }}
          </div>
        </div>

        <Icon name="xia" size="10px" color="#ffffff" />
      </div>
    </NDropdown>
  </div>
</template>

<style lang="scss">
.n-dropdown-option-body {
  height: 32px !important;
  gap: 8px !important;
  padding: 0 20px !important;
}
.n-dropdown-option-body__label {
  font-size: 14px !important;
  height: 32px !important;
  line-height: 32px !important;
}
.n-dropdown-option-body__prefix--show-icon {
  width: fit-content !important;
}

.n-dropdown-option-body__suffix {
  display: none !important;
  padding: 0 !important;
  width: fit-content !important;
  min-width: 0 !important;
}
</style>
